import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { useState } from "react";
import { createPortalQueryClient } from "@/lib/query/core/query-client";

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createPortalQueryClient);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
